<app-feature-tiles-grid
  *ngIf="installationDetailsStore.panelsOrderLoaded$ | async; else loading"
  data-at-wallbox-installation-panels
  cdkDropListGroup
>
  <ng-container *ngFor="let panel of panels; trackBy: trackBy">
    <ng-container [ngSwitch]="panel.panel">
      <!-- Wallbox offline notification -->
      <ng-container *ngIf="devicesStore.isSelectedDeviceWithError$ | async; else wallboxTiles">
        <ng-container *ngSwitchCase="panelTypes.NotificationTile">
          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="orderKey"
              [panel]="panelTypes.NotificationTile"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
            >
              <app-notification-tile></app-notification-tile>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #wallboxTiles>
        <ng-container *ngSwitchCase="panelTypes.WallboxSystem">
          <div
            data-at-wallbox-system
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="orderKey"
              [panel]="panelTypes.WallboxSystem"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-wallbox-system-tile
            >
              <app-wallbox-system data-at-tile="wallbox-system"></app-wallbox-system>
            </app-installation-ordered-element>
          </div>
        </ng-container>

        <!-- Wallbox charging mode -->
        <ng-container *ngSwitchCase="panelTypes.WallboxChargingMode">
          <div
            data-at-wallbox-charging-mode
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="orderKey"
              [panel]="panelTypes.WallboxChargingMode"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-wallbox-charging-mode-tile
            >
              <app-wallbox-charging-mode
                data-at-tile="wallbox-charging-mode"
              ></app-wallbox-charging-mode>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-template>
    </ng-container>
  </ng-container>
</app-feature-tiles-grid>

<ng-template #loading>
  <vi-loader data-at-loader [isLoading]="true"></vi-loader>
</ng-template>
